let lua = require('./stdlib')

let helpers = {
    $slice(arr, start) {
        if (arr.slice) {
            return arr.slice(start)
        } else {
            return Array.prototype.slice.call(arr, start)
        }
    },

    $len(v) {
        if (v && v.__isLuaTable) {
            for (let i = 1; i < v.length; i++) {
                if (v[i] == null) {
                    return i - 1;
                }
            }
            return v.length - 1;
        } else if (v.length || v.length === 0) {
            return v.length
        } else {
            throw new Error(`Attempt to get length of a ${lua.type(v)} value`);
        }
    },

    $null(val) {
        if (val === null || val === undefined) {
            return true
        } else {
            return false
        }
    }
}

module.exports = helpers